import React, { Fragment } from 'react';
import screenshot_4 from "../../../assets/media/DeveloperIntegration/Guides/screenshot_4.png";
const LinktoSite = ()=>{
    return (
        <Fragment>
            <h2>
                How to create your brand Ecosystem and API
            </h2>
            <p style={{marginBottom:30}}>
                Let’s assume you have your own web application and it has tabs in the routing setup,
                so you want to embed your brand customised Ecosystem in your specifically desired pages. 
                We’ve made it easy for you to redirect your page to Ecosystem url.
            </p>
            <p>
                It doesn't matter what you are developing now either web or mobile, 
                you just simply need to create your brand named Ecosystem by signing up at https://brands.ecosystem.co.uk/signup and then signing in at https://brands.ecosystem.co.uk
            </p>
            <img src={screenshot_4} width="80%"/>
            <p>Once you have signed up you have opened the gate to your branded and customisable ecosystem platform
                https://ecosystem.life/[your brand],iframes and API.
            
                We’ve made the iframe and API combination an easy journey, but if you have any issues or queries then then please contact our technical support team through the technical support sub tab, submit and ticket and we’ll help to guide you to your desired solution.
            </p>
        </Fragment>
    );
};
export default LinktoSite;


// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Guides/LinktoSite.js